export const AUTH_USER = 'auth_user';
export const AUTH_ERROR = 'auth_error';
export const SEARCHBAR = 'SEARCHBAR';
export const SEARCHBARSTYLE = 'SEARCHBARSTYLE';
export const DEVICE = 'DEVICE';
export const DRIVERERROR = 'DRIVERERROR';
export const DRIVERERRORCLEAN = 'DRIVERERRORCLEAN';
export const PERMISSIONS = 'PERMISSIONS';



